import { ComponentProps, Suspense, lazy, useEffect, useState } from "react";
import { cachedLoadSkiaWeb, didLoadSkiaWeb } from "../../../helpers/prefetchSkia/prefetchSkia.web";
import type PlayerContentWithPropsType from "../PlayerContentWithProps";

const PlayerContentWithProps = lazy(() => import("../PlayerContentWithProps"));
const PlayerContentLoader = ({ ...props }: ComponentProps<typeof PlayerContentWithPropsType>) => {
	const [isReady, setIsReady] = useState(() => didLoadSkiaWeb());
	useEffect(() => {
		cachedLoadSkiaWeb().then(() => {
			setIsReady(true);
		});
	}, []);

	if (!isReady) return null;
	return (
		<Suspense>
			<PlayerContentWithProps {...props} />
		</Suspense>
	);
};
export default PlayerContentLoader;
